import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import { About, Skills, Experience, Achievements, Contact, Footer } from './components/MainSections';

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Achievements />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
